module.exports = __webpack_public_path__ + "a293b048ff93007308746f2f3bd7dd20.pdf";